import styled from 'styled-components';
import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';

type Props = { $isVisible: boolean; $stickToTop?: boolean };

const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

const CollapsibleSection = styled.div<Props>`
  max-height: ${({ $isVisible }) => ($isVisible ? '800px' : '0')};
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  overflow: hidden;
  transition:
    max-height 0.4s ${EASING},
    opacity 0.3s ${EASING} ${({ $isVisible }) => ($isVisible ? '0.05s' : '0s')};
  background-color: #f5f5f5;

  ${({ $stickToTop }) =>
    $stickToTop &&
    `
    position: sticky;
    top: 48px;
    z-index: 99;

    @media (min-width: ${BREAKPOINTS.tablet}) {
      top: 56px;
    }

    @media (min-width: ${BREAKPOINTS.desktop}) {
      position: static;
    }
  `}

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export default CollapsibleSection;
